import Image from 'next/legacy/image';
import Link from 'next/link';
import { BUTTON_FILLED_STYLE } from '../../components/common/button';
import Layout from '../../components/layout/layout';
import { useTranslation } from '../../lib/i18n';

const AdvicePage = () => {
  const { t } = useTranslation();
  return (
    <Layout className='pt-16'>
      <div className='mx-auto max-w-4xl px-6 text-center 6xl:px-0'>
        <h1>{t('Wir beraten dich auch online')}</h1>

        <div className='grid-cols-1 gap-14 md:mt-16 md:grid md:grid-cols-2 md:gap-20'>
          <div className='flex flex-col'>
            <div className='hidden md:block'>
              <Image
                src='/static/quiz-teaser.png'
                width={234 * 0.924}
                height={231}
                alt='Quiz'
              />
            </div>
            <h2 className='mt-8 text-lg'>{t('quizTitle')}</h2>
            <p className='mb-10 mt-2 flex-grow'>{t('quizText')}</p>
            <Link
              href='/quiz/fragen'
              className={`${BUTTON_FILLED_STYLE} px-10`}
            >
              {t('quizButton')}
            </Link>
          </div>
          <div className='mt-14 border border-green md:hidden'></div>
          <div className='flex flex-col'>
            <div className='hidden md:block'>
              <Image
                src='/static/beratung-teaser.png'
                width={270}
                height={231}
                alt={t('Beratung')}
              />
            </div>
            <h2 className='mt-14 text-lg md:mt-8'>{t('adviceIntro')}</h2>
            <p className='mb-10 mt-2 flex-grow'>{t('adviceDescrption')}</p>
            <Link
              href='/beratung/fragen'
              className={`${BUTTON_FILLED_STYLE} px-10`}
            >
              {t('adviceButtonStart')}
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdvicePage;

export async function getStaticProps({ preview = false }) {
  return {
    props: { preview },
  };
}
